module.exports = __webpack_public_path__ + "img/w3_filter_white.45d7654c.png";